import { QuickArt } from './../../../../../shared/sdk/models/QuickArt';
import { SeCommonConfig } from './../SeCommonConfig.class';
import { IBaseSEConfig } from '../base-se-config.interface';
import * as _ from 'lodash';

export class SeQuickArtConfig extends SeCommonConfig implements IBaseSEConfig {
  // settings just for this element
  public imageURL = '';
  public SeType = 'SeQuickArt';
  public modelRef: QuickArt;
  public poster = '';

  constructor(jsonString?: string) {
    super();
    if (jsonString) {
      this.fromJsonString(jsonString);
    }
  }

  // create json from class vars
  toJson() {
    const obj = super.toJson(); // process common base config settings
    obj.imageURL = this.imageURL; // and any custom props
    obj.SeType = this.SeType;
    obj.modelRef = this.modelRef;
    obj.poster = this.poster;

    obj.files = [];
    if (obj.modelRef) {
      obj.files.push({
        libraryId: this.modelRef.libraryId,
        fileName: this.modelRef.FilenameOnServer,
        hash: this.modelRef.hash
      });
      if (obj.poster) {
        const posterFilename = obj.poster.replace(/^.*[\\\/]/, '');
        this.files.push({
          libraryId: obj.modelRef.libraryId,
          fileName: posterFilename,
          hash: null
        });
      }
    }

    return obj;
  }

  // parse json to class vars
  fromJson(obj) {
    super.fromJson(obj); // process common base config settings
    this.imageURL = _.get(obj, 'imageURL', ''); // get val in safe way with defalut
    this.SeType = _.get(obj, 'SeType', 'SeQuickArt');
    this.modelRef = _.get(obj, 'modelRef', null);
    this.poster = _.get(obj, 'poster', '');

    // override some props that werer filled in by super call
    this.sizeInBytes = _.get(obj, 'modelRef.FileSize', 0);

    this.files = [];
    if (this.modelRef) {
      this.files.push({
        libraryId: this.modelRef.libraryId,
        fileName: this.modelRef.FilenameOnServer,
        hash: this.modelRef.hash
      });

      if (obj.poster) {
        const posterFilename = obj.poster.replace(/^.*[\\\/]/, '');
        this.files.push({
          libraryId: obj.modelRef.libraryId,
          fileName: posterFilename,
          hash: null
        });
      }

    }

  }

  toJsonString() {
    return JSON.stringify(this.toJson());
  }

  fromJsonString(str) {
    this.fromJson(JSON.parse(str));
  }


}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-quickart/se-quickart-config.class.ts